import { useDispatch, useSelector } from 'react-redux'

import type { RootThunkDispatch } from 'store'
import { authenticate, register, logout } from 'store/user/actions'
import {
  getLoginButtonStrings,
  getLoginFormStrings,
  getRegisterFormStrings,
} from 'store/strings/selectors'
import { getUserFirstName } from 'store/user/selectors'
import Login from 'ui-component-library/components/Login'

const FORGOT_PASSWORD_URL = process.env.FORGOT_PASSWORD_URL || ''

type AuthenticateParams = {
  email: string
  password: string
}

type RegisterParams = {
  email: string
  firstName: string
  lastName: string
  password: string
  birthDay: string
  birthMonth: string
  birthYear: string
}

function LoginContainer() {
  const dispatch = useDispatch<RootThunkDispatch>()
  const loginButton = useSelector(getLoginButtonStrings)
  const loginForm = useSelector(getLoginFormStrings)
  const registerForm = useSelector(getRegisterFormStrings)
  const userFirstName = useSelector(getUserFirstName)

  function handleLogout() {
    dispatch(logout())
  }

  function handleAuthenticate(params: AuthenticateParams): Promise<void> {
    return dispatch(authenticate(params))
  }

  function handleRegister(params: RegisterParams) {
    return dispatch(register(params))
  }

  return (
    <Login
      loginButton={{
        ...loginButton,
        isLoggedIn: Boolean(userFirstName),
        userFirstName,
        onLogout: handleLogout,
      }}
      loginForm={{
        ...loginForm,
        onAuthenticate: handleAuthenticate,
        forgotPasswordUrl: FORGOT_PASSWORD_URL,
      }}
      registerForm={{
        ...registerForm,
        onRegister: handleRegister,
      }}
    />
  )
}

export default LoginContainer
